//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/UserDefinedTemplate.js";
import "../UserDefinedTemplate/UserDefinedTemplate.ItemNodeCae.js";
let d=[[],[[[],"CloseGraphWindows",{},0,0],[["action"],"ExecuteAction",{},1,0]],[]];
SPLM.UserDefinedTemplate.ItemNodeMotionSolution = class extends SPLM.UserDefinedTemplate.ItemNodeCae{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.UserDefinedTemplate.ItemNodeMotionSolution";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.UserDefinedTemplate.ItemNodeMotionSolution.Action = Object.freeze({
    "ShowGraph" : "ShowGraph", "NextGraph" : "NextGraph", "ReturnToModel" : "ReturnToModel", "RunSolver" : "RunSolver"});

export default SPLM;